














































































































import ResponsiveImage from '@/components/common/Image.vue';
import RichTextDisplay from '@/components/common/RichTextDisplay.vue';
import SocialMediaButtons from '@/components/common/SocialMediaButtons.vue';
import CampaignQuery from '@/graphql/queries/campaign.gql';
import ContributionsQuery from '@/graphql/queries/contributions.gql';
import request from '@/graphql/request';
import { clearInterval, setInterval } from 'timers';
import { Component, Prop, Vue } from 'vue-property-decorator';

const CONTRIBUTION_REFRESH_INTERVAL = 1000; // in ms

@Component({
  components: {
    RichTextDisplay,
    SocialMediaButtons,
    ResponsiveImage,
  },
})
export default class ShowCampaign extends Vue {
  public id: string = '';
  public isOver: boolean = false;
  public campaign: {
    id: string;
    name: string;
    description: string;
    goal: number;
    raised: number;
    endDateTime: Date;
    heroMedia?: {
      id: string;
      url: string;
      type: string;
    };
    contributions: Array<{
      sourceName: string;
      amount: number;
      createdAt: Date;
    }>;
  } = {} as any;

  private contributionTimer?: NodeJS.Timer;
  private currentTimeInterval?: NodeJS.Timer;

  public mounted() {
    this.id = this.$route.query.id || this.$route.params.id;

    request(CampaignQuery, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No campaign returned');
          return;
        }

        this.campaign = response.data.campaign;

        if (!this.campaign) {
          this.$router.push('/');
        }

        document.title = this.campaign.name;

        if (Date.now() > +new Date(this.campaign.endDateTime)) {
          this.isOver = true;
        }

        if (this.campaign && !this.isOver && !this.isFunded) {
          this.watchContributions();
        }
      })
      .catch(console.error);
  }

  public beforeDestroy() {
    if (this.contributionTimer) {
      clearTimeout(this.contributionTimer);
    }
    if (this.currentTimeInterval) {
      clearInterval(this.currentTimeInterval);
    }
  }

  get isFunded(): boolean {
    return this.campaign && this.campaign.raised >= this.campaign.goal;
  }

  get recentContributions(): Array<{
    sourceName: string;
    amount: number;
    createdAt: Date;
  }> {
    if (this.campaign.contributions && this.campaign.contributions.length) {
      return this.campaign.contributions
        .sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt))
        .slice(0, 5);
    }

    return [];
  }

  public formatDate(date: string | Date) {
    return new Date(date).toLocaleDateString(undefined, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  public calculatePercentage() {
    return (this.campaign.raised / this.campaign.goal) * 100 || 0;
  }

  public showName(name: string) {
    if (!name) {
      return 'Anonymous';
    }

    const firstSpace = name.indexOf(' ');
    return firstSpace > -1 ? name.substr(0, firstSpace) : name;
  }

  private formatDonorTime(date: string): string {
    const now = Date.now();
    const timeDiff = Math.round((now - +new Date(date)) / 1000);

    if (timeDiff < 60) {
      return `${timeDiff} seconds ago`;
    } else if (timeDiff < 60 * 60) {
      return `${Math.round(timeDiff / 60)} minutes ago`;
    } else if (timeDiff < 60 * 60 * 24) {
      return `${Math.round(timeDiff / 60 / 60)} hours ago`;
    } else {
      return `${Math.round(timeDiff / 60 / 60 / 24 / 30)} days ago`;
    }
  }

  private watchContributions() {
    const contributionTimeout = () => {
      this.contributionTimer = setTimeout(async () => {
        try {
          const response = await request(ContributionsQuery, {
            campaignId: this.campaign.id,
          });
          if (response && response.data && response.data.contributions) {
            const {
              data: { contributions },
            } = response;
            if (contributions.length >= this.campaign.contributions.length) {
              this.campaign.contributions = contributions;
              this.campaign.raised = contributions.reduce(
                (total: number, c: any) =>
                  total + (parseInt(c.amount, 10) || 0),
                0
              );
            }
          }
        } catch (e) {
          console.error(e);
        }

        contributionTimeout();
      }, CONTRIBUTION_REFRESH_INTERVAL);
    };

    contributionTimeout();
  }
}
